import { render, staticRenderFns } from "./DigitalMailRestrictions.vue?vue&type=template&id=8f379760&"
import script from "./DigitalMailRestrictions.vue?vue&type=script&lang=js&"
export * from "./DigitalMailRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports